var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 265,
    viewBox: "0 0 265 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_992_1662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.979 168.219C235.197 160.502 224.546 153.834 212.32 148.401C207.094 146.08 200.978 148.434 198.657 153.658C196.336 158.882 198.689 164.998 203.914 167.321C214.223 171.903 223.106 177.436 230.314 183.771C239.2 191.579 244.297 202.885 244.297 214.795V233.945C244.297 239.653 239.653 244.297 233.945 244.297H31.0547C25.3472 244.297 20.7031 239.653 20.7031 233.945V214.795C20.7031 202.885 25.8001 191.579 34.6858 183.771C45.1445 174.58 75.617 153.203 132.5 153.203C174.737 153.203 209.102 118.839 209.102 76.6016C209.102 34.3644 174.737 0 132.5 0C90.2628 0 55.8984 34.3644 55.8984 76.6016C55.8984 101.294 67.645 123.291 85.8411 137.308C52.5463 144.627 31.8351 158.715 21.0205 168.219C7.66258 179.955 0 196.93 0 214.795V233.945C0 251.07 13.9301 265 31.0547 265H233.945C251.07 265 265 251.07 265 233.945V214.795C265 196.93 257.337 179.955 243.979 168.219ZM76.6016 76.6016C76.6016 45.7794 101.678 20.7031 132.5 20.7031C163.322 20.7031 188.398 45.7794 188.398 76.6016C188.398 107.424 163.322 132.5 132.5 132.5C101.678 132.5 76.6016 107.424 76.6016 76.6016Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_992_1662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 265,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.303d1b91dc2c0c15f3db671939b5e381.svg";
export { ForwardRef as ReactComponent };